
// add lazy-load supported
import LazyLoad from "vanilla-lazyload";
let myLazyLoad = new LazyLoad();

//import tiny-slider
import { tns } from "tiny-slider/src/tiny-slider";
document.addEventListener("DOMContentLoaded", function() {
	// tiny-slider init
	let slider = document.querySelector(".slider");
	if (slider) {
		tns({
			container: ".slider",
			items: 1,
			slideBy: "page",
			autoHeight: false,
			autoplay: false,
			loop: true,
			gutter: 20,
			nav: true,
			lazyload: true,
			controls: false,
			touch: true,
			mouseDrag: true,
			autoplayButtonOutput: false
		});
	}

	// mobile menu
	const menuButton = document.querySelector('.mobile-menu');
	const menuContainer = document.querySelector('.mobile-menu-container');
	const topNav = document.querySelector('nav.top');

	if (menuButton && menuContainer && topNav) {
		menuButton.addEventListener('click', function() {
			if (topNav.style.display === 'none' || topNav.style.display === '') {
				topNav.style.display = 'block';
			} else {
				topNav.style.display = 'none';
			}
			menuContainer.classList.toggle('mobile-menu-container--open');
		});
	}
});


// load iframe
(function(){
    'use strict';
    //--------------------------------------------------------------------------------------------------------------
    //	LOAD IFRAME GAME
    //--------------------------------------------------------------------------------------------------------------
    (function(){
        let wrap = document.getElementById('js_game');
        if (wrap){
            loadGame();
        }

        function loadGame(){
            let btn = wrap.getElementsByTagName('button')[0];
            if (btn){
                btn.addEventListener('click', loadFrame);
            }

            function loadFrame(){
                let frame = document.createElement('iframe'),
                    src = wrap.getAttribute('data-game');

                frame.setAttribute('src', src);
                btn.removeEventListener('click', loadFrame);
                wrap.innerHTML = '';
                wrap.appendChild(frame);
            }
        }
    })();
})();

const top_button = document.querySelector("#up_button");
window.addEventListener("scroll", ()=>{
    if (window.scrollY > 500) {
        top_button.style.display = "block"
    } else {
        top_button.style.display = "none"
    }
})
